import { NgModule } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { AdmitActionLinkComponent } from "./admit.action.link.component";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { FormsModule } from "@angular/forms";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { NgTemplateOutlet } from "@angular/common";

@NgModule({
    declarations: [AdmitActionLinkComponent],
    imports: [S25ButtonComponent, FormsModule, S25ModalModule, S25IconComponent, NgTemplateOutlet],
    providers: [AdmitActionLinkComponent],
    exports: [AdmitActionLinkComponent],
})
export class AdmitModule {
    constructor() {}
}
